"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _ui = require("../../../ui");
var _layout = require("../../../layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WalletDropdown = function WalletDropdown(_ref) {
  var collapse = _ref.collapse,
    sendPath = _ref.sendPath,
    receivePath = _ref.receivePath,
    walletsPath = _ref.walletsPath,
    transactionsPath = _ref.transactionsPath;
  var _useTranslation = (0, _reactI18next.useTranslation)('libLayout'),
    t = _useTranslation.t;
  var history = (0, _reactRouterDom.useHistory)();
  var Component = collapse ? _layout.LayoutHeaderDropdownCollapse : _ui.DropdownMenu;
  return /*#__PURE__*/_react.default.createElement(_ui.Dropdown, {
    collapse: collapse
  }, /*#__PURE__*/_react.default.createElement(_ui.DropdownToggle, {
    id: "walletCollapse",
    onClick: function noRefCheck() {}
  }, /*#__PURE__*/_react.default.createElement(_ui.H5, null, t('dashboard.header.walletDropdown.title'))), /*#__PURE__*/_react.default.createElement(Component, {
    toggler: "#walletCollapse"
  }, /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItem, {
    title: t('dashboard.header.walletDropdown.items.send.title'),
    subtitle: t('dashboard.header.walletDropdown.items.send.desc'),
    icon: /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItemIcon, {
      name: "arrowRotate",
      rotate: 180
    }),
    onClick: function onClick() {
      return history.push(sendPath);
    }
  }), /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItem, {
    title: t('dashboard.header.walletDropdown.items.receive.title'),
    subtitle: t('dashboard.header.walletDropdown.items.receive.desc'),
    icon: /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItemIcon, {
      name: "arrowRotate"
    }),
    onClick: function onClick() {
      return history.push(receivePath);
    }
  }), /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItem, {
    title: t('dashboard.header.walletDropdown.items.addresses.title'),
    subtitle: t('dashboard.header.walletDropdown.items.addresses.desc'),
    icon: /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItemIcon, {
      name: "wallet"
    }),
    onClick: function onClick() {
      return history.push(walletsPath);
    }
  }), /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItem, {
    title: t('dashboard.header.walletDropdown.items.transactions.title'),
    subtitle: t('dashboard.header.walletDropdown.items.transactions.desc'),
    icon: /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItemIcon, {
      name: "history"
    }),
    onClick: function onClick() {
      return history.push(transactionsPath);
    }
  })));
};
exports.WalletDropdown = WalletDropdown;